import { Stack } from '@ltvco/refresh-lib/theme';

import {
  type AstrologyCompatibilityProps,
  withAstrologyCompatibility,
} from 'components/Astrology/AstrologyCompatibility/AstrologyCompatibility';
import { CompatibilityHeader } from 'components/Astrology/AstrologyHeaders';

import { AstrologyStandaloneSectionTextField } from '../components';

const SummaryContent = ({ content }: AstrologyCompatibilityProps) => {
  return <AstrologyStandaloneSectionTextField content={content} rows={5} />;
};

const AstrologyStandaloneCompatibilityContent =
  withAstrologyCompatibility(SummaryContent);

interface AstrologyStandaloneCompatibilityProps {
  zodiacSign: string;
  compatibilitySign: string;
  // eslint-disable-next-line no-unused-vars
  setCompatibilitySign: (sign: string) => void;
}

export const AstrologyStandaloneCompatibility = ({
  zodiacSign,
  compatibilitySign,
  setCompatibilitySign,
}: AstrologyStandaloneCompatibilityProps) => {
  return (
    <Stack p={1.5}>
      <CompatibilityHeader
        value={zodiacSign}
        selectValue={compatibilitySign}
        onChangeCallback={(sign) => setCompatibilitySign(sign)}
        standaloneVersion
      />
      <AstrologyStandaloneCompatibilityContent
        zodiacSign={zodiacSign}
        compatibilitySign={compatibilitySign}
      />
    </Stack>
  );
};
